export default __webpack_public_path__ + "static/media/logo-Claridge_Pink.937dbaee.svg";